import React from 'react';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';

const Services = () => {
  const ref = useIntersectionObserver();

  const services = [
    {
      title: 'Web & Full-Stack Development',
      desc: 'Build scalable and responsive web applications using React.js, Next.js, ASP.NET, and Python backends. Focus on clean architecture, performance, and user experience.'
    },
    {
      title: 'AI & Automation Solutions',
      desc: 'Develop AI-powered features including chatbots, recommendation systems, data analysis dashboards, and workflow automation using Python, FastAPI, and ML toolkits.'
    },
    {
      title: 'Database & Backend Engineering',
      desc: 'Design and optimize databases with SQL, PostgreSQL, and Supabase. Implement secure RESTful APIs, authentication systems, and deployment-ready backend solutions.'
    },
    {
      title: 'WordPress & Website Management',
      desc: 'Create and manage WordPress websites for international clients, including e-commerce, landing pages, and SEO optimization. Handle hosting and integrations via platforms like Hostinger.'
    },
    {
      title: 'Graphic Design & Content Creation',
      desc: 'Design graphics, marketing visuals, and video content. Utilize tools for video editing, UI graphics, and creative digital assets.'
    },
    {
      title: 'Digital Marketing & SEO',
      desc: 'Manage social media, lead generation, SEO, and campaigns for businesses and clients. Focus on engagement, conversions, and brand growth.'
    },
    {
      title: 'Consulting & Mentorship',
      desc: 'Architect software solutions, review code, provide guidance on projects, and mentor teams or individuals in AI, web development, and automation.'
    }
  ];

  return (
    <section id="services" className="section bg">
      <div ref={ref} className="container container-lg" data-animate>
        <h2>Services</h2>
        <div className="services">
          {services.map(service => (
            <div key={service.title} className="service">
              <h5>{service.title}</h5>
              <p>{service.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
